import { WishtlingIcon } from '../../../utils/svg';

const Empty = () => {
	return (
		<div className='w-full h-full flex justify-center items-center flex-col'>
			<WishtlingIcon className={'fill-[var(--rose-violet)]'} />
			<div className='gap-4 text-center'>
				<div className='text-gray-700 font-semibold text-sm'>Kami tidak dapat menemukan hasil apa pun.</div>
				<div className='text-gray-700 font-normal text-xxs'>Coba menu pencarian atau menu kategori yang berbeda di pedagang ini.</div>
			</div>
		</div>
	);
};

export default Empty;
